/**
 *  Retrieve faqs on page based on data-faqname="xxx"
 */
function getFaqsOnPage() {
    const faqNames = [];
    $('[data-faqname]').each(function () {
        const faqName = $(this).attr('data-faqname');
        if (!faqNames.hasOwnProperty(faqName)) {
            faqNames.push(faqName);
        }
    });
    if (faqNames.length > 0) {
        const srcString = secureBaseURL + 'common/json-faq.html?callback=addFaqsToTooltips&faqNames=' + faqNames.join(',');
        const e = document.createElement('script');
        e.src = srcString;
        e.async = true;
        e.type = 'text/javascript';
        document.getElementsByTagName('head')[0].appendChild(e);
    }
}

window.addFaqsToTooltips = (data) => {
    if (data) {
        const faqs = data.data;
        $('.populate-tooltip').each(function () {
            if (faqs[$(this).attr('data-faqname')] && $(this).next('.hover-tooltip').length === 0) {
                $(this).after('<span class="hover-tooltip">' + faqs[$(this).attr('data-faqname')] + '</span>');
            }
        });
    }
};

$(document).ready(function () {
    getFaqsOnPage();
});
